import { apiv2 } from "./api";
import { AxiosError } from 'axios';
import type { AuthBodyType } from "../types";
import type { TicketModel } from "../types/tickets/types";

class NovoChamado {


  getList = async (token: AuthBodyType): Promise<TicketModel[] | undefined> => {
    try {
      const data = await apiv2.get("chamados/modelos", {
        headers: { ...token },
      });
      return data.data?.success ? data.data.data.modelos : undefined;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return undefined;
      }
    }
  };

  createModel = async (token: AuthBodyType, ticket: Omit<TicketModel, "id">) => {
    try {
      const data = await apiv2.post("chamados/modelos", {
        ...token,
        ticket,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        throw new Error(error.message);
      }
    }
  };

  updateModel = async (token: AuthBodyType, ticket: TicketModel) => {
    try {
      const data = await apiv2.patch(`chamados/modelos/${ticket.id}`, {
        ...token,
        ticket,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        throw new Error(error.message);
      }
    }
  };

  deleteModel = async (token: AuthBodyType, ticketId: string) => {
    try {
      const data = await apiv2.delete(`chamados/modelos/${ticketId}`, { data: { ...token } });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };
}

export default NovoChamado;
